angular.module('unergie.main')
.controller('directoryCtrl', ($q, $scope, $state, TableGeneratorService, NgTableParams, ApiAdmin, ModalService, FilterMapping) => {
    $scope.simpleStatusMapping = _.keyBy(FilterMapping.simpleStatuses, 'id')
    $scope.customers = {
        show: {},
        refreshing: false,
        columns: {
            customer_id: { label: 'ID CLient', mode: 'search_wildcard' },
            fullname: { label: 'Nom Prénom', mode: 'search_wildcard' },
            mail: { label: 'Adresse mail', mode: 'search_wildcard' },
            phone: { label: 'Numéro de téléphone', mode: 'search_wildcard' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.customers, 'vw-bulk-purchase-client', null, null, { orderBy: 'fullName' })

    $scope.expandCustomer = (datum, force) => {
        if (datum) {
            if (!datum.expanded || force) {
                datum.refreshing = true
                datum.expanded = force || !datum.expanded
                return ApiAdmin.getBulkPurchaseClientDetail({ customer_id: datum.customer_id }).$promise
                .then((elements) => {
                    datum.contractsElec = new NgTableParams({ count: 12 }, {
                        counts: [],
                        dataset: elements.contracts,
                    })
                    datum.complaints = new NgTableParams({ count: 12 }, {
                        counts: [],
                        dataset: elements.complaints,
                    })
                    datum.refreshing = false
                })
            }
            datum.expanded = !datum.expanded
        }
    }

    $scope.openNewComplaintModal = (event, contractElec, datum) => {
        event.preventDefault()
        event.stopPropagation()
        ModalService.openModal({ type: 'newComplaintModal', size: 'md', backdrop: 'static' }, { contractElec }, () => {
            $scope.expandCustomer(datum, true)
        })
    }


    $scope.refresh()
})
